import { render, staticRenderFns } from "./applicants-summary.vue?vue&type=template&id=2b38718a&scoped=true"
import script from "./applicants-summary.vue?vue&type=script&lang=ts"
export * from "./applicants-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38718a",
  null
  
)

export default component.exports